import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './SalesStartInfo.css';
import { SalesStartTooltip } from '../SalesStartTooltip';

interface ISalesStartInfo {
  content: string;
}

export function SalesStartInfo({ content }: ISalesStartInfo) {
  return (
    <ArticleParagraph2>
      {content}
      <span className={styles['tooltip']}>
        <SalesStartTooltip />
      </span>
    </ArticleParagraph2>
  );
}
